import { motion } from 'framer-motion'
import { Star, Quote } from 'lucide-react'

const testimonials = [
  {
    name: 'Carlos Mendonça',
    location: 'Balneário Camboriú',
    rating: 5,
    text: 'Serviço impecável! Chamei para consertar umas tomadas e ele resolveu tudo rapidinho, com muito capricho. Profissional e pontual. Super recomendo!',
    service: 'Reparos Elétricos',
  },
  {
    name: 'Ana Paula Costa',
    location: 'Itapema, SC',
    rating: 5,
    text: 'Montagem de móveis feita com muita precisão e cuidado. Profissional pontual, organizado e deixou tudo limpo após o serviço. Excelente experiência!',
    service: 'Montagem de Móveis',
  },
  {
    name: 'Ricardo Alves',
    location: 'Camboriú, SC',
    rating: 5,
    text: 'Usei o serviço de frete para uma pequena mudança. Muito atencioso, rápido e preço bastante justo. Com certeza vou chamar novamente.',
    service: 'Freteiro',
  },
]

const TestimonialsSection = () => {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#F7F7F7]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="mb-14 lg:mb-16">
          <motion.p
            className="text-[#F2B300] text-[11px] font-bold uppercase tracking-[0.2em] mb-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            Depoimentos
          </motion.p>
          <motion.h2
            className="text-4xl sm:text-5xl font-bold text-[#062B63] font-outfit tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.6 }}
          >
            O que dizem nossos clientes
          </motion.h2>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${i + 1}`}
              className="bg-white p-7 lg:p-8 border border-[#062B63]/5 relative group overflow-hidden"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
            >
              {/* Quote icon */}
              <Quote
                size={36}
                className="text-[#F2B300]/25 mb-5"
                style={{ fill: 'rgba(242,179,0,0.12)' }}
              />

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} size={14} className="text-[#F2B300] fill-[#F2B300]" />
                ))}
              </div>

              {/* Review text */}
              <p className="text-[#062B63]/65 text-sm leading-relaxed mb-7">"{t.text}"</p>

              {/* Author row */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[#062B63] font-bold text-sm">{t.name}</p>
                  <p className="text-[#062B63]/45 text-xs mt-0.5">{t.location}</p>
                </div>
                <span className="text-[10px] text-[#F2B300] font-bold uppercase tracking-wider border border-[#F2B300]/30 px-2.5 py-1 bg-[#F2B300]/5">
                  {t.service}
                </span>
              </div>

              {/* Bottom gold accent */}
              <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#F2B300] group-hover:w-full transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
